import React, { Component } from 'react';

import * as IconLookupMap from '../util/iconLookupMap.json';

// add css/font files for devicons or use svgs

class IconWrap extends Component {

  constructor(props) {
    super(props);

    this.icon = IconLookupMap[props.icon];
    this.showIcon = props.showIcon || false;
    this.showTitle = props.showTitle || false;
  }

  render() {
    return (
      <div className="icon-wrap">
        {(this.showIcon && this.icon && this.icon.src) &&
          <img src={this.icon.src} alt={this.icon.title} />
        }
        <p>{(this.showTitle && this.icon) ? this.icon.title : ''}</p>
      </div>
    );
  }

}

export default IconWrap;


// WEBPACK FOOTER //
// ./src/components/IconWrap.js